import React from 'react'
import Colors from 'colors.json'
import { Form, Formik } from 'formik'

import DatetimePickerInput from 'components/DatetimePickerInput'
import Input from 'components/Input'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { DropDownItem } from 'types/components'
import { UpdateMerchantBankAccountsFetchParamsSchemasYup } from 'schemas/merchantBankAccountsSchemas'
import { MerchantBankAccountTypes } from 'types/merchant'

import { useUpdateBankAccount } from './useUpdateBankAccount'

const MERCHANTBANKACCOUNTTYPEOPTIONS: DropDownItem[] = [
  { label: 'Std Bank Account', value: '1' },
]

interface PropsTypes {
  onCloseModal: () => void
  selectedMerchantBankAccount: MerchantBankAccountTypes
}

const Index: React.FC<PropsTypes> = ({
  onCloseModal,
  selectedMerchantBankAccount,
}): React.ReactElement => {
  // STATES
  const { isLoading, initialValues, handleSubmitUpdateMerchantBankAccount } =
    useUpdateBankAccount(selectedMerchantBankAccount, onCloseModal)

  if (isLoading) return <></>

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={UpdateMerchantBankAccountsFetchParamsSchemasYup}
      onSubmit={handleSubmitUpdateMerchantBankAccount}
    >
      {({ values, isSubmitting, setFieldValue, errors, touched }) => {
        return (
          <Form className="flex flex-col">
            <div>
              <div>
                <div className="mb-0">
                  <Dropdown
                    title="Account Types"
                    options={MERCHANTBANKACCOUNTTYPEOPTIONS}
                    className="w-full tracking-wider mb-4"
                    borderColor="#C4C4C4"
                    onSelect={(data) =>
                      setFieldValue('bankAccountTypeId', String(data.value))
                    }
                    value={MERCHANTBANKACCOUNTTYPEOPTIONS[0]}
                    disabled
                  />
                  {/* <Input
                    name="bankAccountNumber"
                    label="Account Number"
                    containerClassName="w-full"
                    type="input"
                    disabled
                  /> */}
                </div>
                <Input
                  name="name"
                  label="Account Name"
                  containerClassName="w-full"
                  type="input"
                  disabled
                />
                {/* <Input
                  name="safetyCode"
                  label="Security Code"
                  containerClassName="w-full"
                  type="input"
                /> */}
              </div>
              <div className="flex gap-4 justify-between">
                <DatetimePickerInput
                  title={'Expiry Date'}
                  setFieldName="expiryDate"
                  setFieldValue={setFieldValue}
                  showTimeSelect={false}
                  scrollableYearDropdown={true}
                  defaultDateValue={
                    values.expiryDate ? values.expiryDate.slice(0, 10) : ''
                  }
                />
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <Input
                name="payerPartyCode"
                label="Payer Party Code"
                containerClassName="w-full"
                type="input"
              />
              <Input
                name="payerPartyParticulars"
                label="Payer Party Particulars"
                containerClassName="w-full"
                type="input"
              />
            </div>
            <div className="flex gap-4 items-center">
              <Input
                name="payeePartyParticulars"
                label="Payee Party Particulars"
                containerClassName="w-full"
                type="input"
              />
              <Input
                name="payeePartyCode"
                label="Payee Party Code"
                containerClassName="w-full"
                type="input"
              />
            </div>
            <Input
              name="payeePartyRef"
              label="Payee Party Reference"
              containerClassName="w-full"
              type="input"
            />
            <div className="flex items-center mb-6">
              <label
                htmlFor="flEmail"
                className="text-gray-500 mr-2 font-light"
              >
                Make Default
              </label>
              <input
                type="checkbox"
                id="isDefaultBankAccount"
                name="isDefaultBankAccount"
                className="mr-2"
                checked={values.isDefaultBankAccount === 1}
                onChange={(e) => {
                  setFieldValue(
                    'isDefaultBankAccount',
                    e.target.checked ? 1 : 0
                  )
                }}
              />
            </div>
            <footer className="flex justify-end pb-4 pl-4 pr-0">
              <Button
                type="submit"
                className="mr-2 rounded bg-primary"
                disabled={isSubmitting}
              >
                <span className="tracking-wider font-bold">Submit</span>
              </Button>
              <Button
                className="bg-white border rounded border-primary"
                onClick={onCloseModal}
                style={{ color: Colors.primary }}
              >
                <span className="tracking-wider font-bold">Cancel</span>
              </Button>
            </footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Index
